module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAMxJREFUKBXFUcENwjAMPEfMA0wAv7IEiCIoLwSzUPFCVAi1U3QKWvbp4aS8kiDBq37Eyp3PvsSySLMGImN4QSCv79dTstmfBTh6NEC2JibsCzlxmZgGQgvoQBMlfgQHFFMj7lI6iwvosl9jdSMFLwSD3wZRWYF2LvXUDw+iDZB/AEnSLFdv4eSOZf24Fcl6t4WRld9Urbys7YPo0nySxr25EJGlvnwe8OTMKBkI+0K6NRISXafVRQl/yrf7gGLdYxOzJcTT4fLJXpHVvQH56zlXriDZ9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-group.png
// module id = 2018
// module chunks = 0